// src/utils/IdleTimer.ts
class IdleTimer {
  timeout: number;
  onTimeout: () => void;
  eventHandler: () => void;
  timeoutTracker: NodeJS.Timeout | undefined;
  interval: NodeJS.Timeout | undefined;

  constructor({
    timeout,
    onTimeout,
  }: {
    timeout: number;
    onTimeout: () => void;
  }) {
    this.timeout = timeout;
    this.onTimeout = onTimeout;

    this.eventHandler = this.updateExpiredTime.bind(this);
    this.tracker();
    this.startInterval();
  }

  // Start the interval to track timeout
  startInterval() {
    this.updateExpiredTime();

    // Set an interval to check every second (1000ms)
    this.interval = setInterval(() => {
      const expiredTime = parseInt(
        localStorage.getItem('_expiredTime') || '0',
        10,
      );

      if (expiredTime < Date.now()) {
        if (this.onTimeout) {
          this.onTimeout();
          this.cleanUp(); // Clean up after timeout
        }
      }
    }, 1000);
  }

  // Update the expiration time when there is user activity
  updateExpiredTime() {
    if (this.timeoutTracker) {
      clearTimeout(this.timeoutTracker);
    }
    this.timeoutTracker = setTimeout(() => {
      localStorage.setItem('_expiredTime', Date.now() + this.timeout * 1000);
    }, 300);
  }

  // Track user interactions to reset timeout
  tracker() {
    window.addEventListener('mousemove', this.eventHandler);
    window.addEventListener('scroll', this.eventHandler);
    window.addEventListener('keydown', this.eventHandler);
  }

  // Clean up after the timeout occurs
  cleanUp() {
    localStorage.removeItem('_expiredTime');
    clearInterval(this.interval);
    window.removeEventListener('mousemove', this.eventHandler);
    window.removeEventListener('scroll', this.eventHandler);
    window.removeEventListener('keydown', this.eventHandler);
  }
}

export default IdleTimer;
